import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { nativeLoad3gm9heja6i3t0 as nativeLoad } from './RawImageView.commonHtml.js.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  revokeObjectURLfycm7e1b77ci as revokeObjectURL,
  createObjectURLFileReference3o8golj1mnrvr as createObjectURLFileReference,
  createObjectURLBlob28c4i1stg1nh2 as createObjectURLBlob,
} from './ImageView.commonHtml.js.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  vectorToSvgDataUrl2gfp16zcspd2w as vectorToSvgDataUrl,
  ImageResource1861inqz1dzjl as ImageResource,
} from '../../models/data.commonHtml.mjs';
import {
  ImageVector2g5mdtb71xbxl as ImageVector,
  ImageLocal23zvpfzvp93up as ImageLocal,
  ImageRaw13ec2czmt8f60 as ImageRaw,
  ImageRemote256pcav1ipbca as ImageRemote,
} from '../../models/data.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RawImageViewClass;
function RawImageView() {
  if (RawImageViewClass === VOID) {
    class $ extends RawImageViewLike() {
      constructor(context, source, description, scaleType) {
        super(context, source, description, scaleType);
        this.native_1.tag_1 = 'img';
        this.native_1.classes_1.add_utx5q5_k$('viewDraws');
        // Inline function 'com.lightningkite.kiteui.views.alt' call
        this.native_1.attributes_1.native_1.alt = description;
        // Inline function 'com.lightningkite.kiteui.views.loading' call
        this.native_1.attributes_1.native_1.loading = 'lazy';
        this.state_1 = this._state_1;
        nativeLoad(this, this.toUrl_pxesg3_k$(source));
      }
    }
    initMetadataForClass($, 'RawImageView');
    RawImageViewClass = $;
  }
  return RawImageViewClass;
}
var RawImageViewLikeClass;
function RawImageViewLike() {
  if (RawImageViewLikeClass === VOID) {
    class $ extends NativeElement() {
      constructor(context, source, description, scaleType) {
        super(context);
        this.source_1 = source;
        this.description_1 = description;
        this.scaleType_1 = scaleType;
        this._state_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$();
        this.currentBlobUrl_1 = null;
        this.native_1.classes_1.add_utx5q5_k$('scaleType-' + this.scaleType_1.toString());
        onRemove(this, () => {
          var tmp0_safe_receiver = this.currentBlobUrl_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            revokeObjectURL(tmp0_safe_receiver);
          }
          this.currentBlobUrl_1 = null;
          return Unit_instance;
        });
      }
      toUrl_pxesg3_k$(_this__u8e3s4) {
        var tmp0_safe_receiver = this.currentBlobUrl_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          revokeObjectURL(tmp0_safe_receiver);
        }
        this.currentBlobUrl_1 = null;
        var value = _this__u8e3s4;
        var tmp;
        if (value == null) {
          tmp = '';
        } else {
          if (value instanceof ImageRemote()) {
            tmp = value.url_1;
          } else {
            if (value instanceof ImageRaw()) {
              // Inline function 'kotlin.also' call
              var this_0 = createObjectURLBlob(value.data_1);
              this.currentBlobUrl_1 = this_0;
              tmp = this_0;
            } else {
              if (value instanceof ImageResource()) {
                tmp = this.get_context_h02k06_k$().basePath_1 + value.relativeUrl_1;
              } else {
                if (value instanceof ImageLocal()) {
                  // Inline function 'kotlin.also' call
                  var this_1 = createObjectURLFileReference(value.file_1);
                  this.currentBlobUrl_1 = this_1;
                  tmp = this_1;
                } else {
                  if (value instanceof ImageVector()) {
                    tmp = vectorToSvgDataUrl(value);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'RawImageViewLike');
    RawImageViewLikeClass = $;
  }
  return RawImageViewLikeClass;
}
//region block: exports
export {
  RawImageView as RawImageView3rlp4gsc2bxt0,
};
//endregion

//# sourceMappingURL=RawImageView.commonHtml.mjs.map
